import { Hourglass, Upload, Users } from 'lucide-react';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import type { ListFilter, ListFilterChip } from '@/lib/library/listFilters';
import { cn } from '@/lib/utils';

const ICONS: Partial<Record<ListFilter, ReactNode>> = {
  uploaded: <Upload className="h-3.5 w-3.5" />,
  community: <Users className="h-3.5 w-3.5" />,
  expired: <Hourglass className="h-3.5 w-3.5" />,
};

interface Props {
  chips: ListFilterChip[];
  value: ListFilter;
  onChange: (filter: ListFilter) => void;
}

/** "Todos 38 · Enviados 15 · Comunidade 23 · Expirados 96" above a list. */
export function ListFilterChips({ chips, value, onChange }: Props) {
  const { t } = useTranslation();
  return (
    <div
      role="group"
      aria-label={t('lists.filtersLabel')}
      className="-mx-4 flex gap-2 overflow-x-auto px-4 pb-1 [scrollbar-width:none] sm:mx-0 sm:flex-wrap sm:px-0"
    >
      {chips.map((chip) => {
        const active = chip.key === value;
        return (
          <button
            key={chip.key}
            type="button"
            data-testid={`list-filter-${chip.key}`}
            aria-pressed={active}
            onClick={() => onChange(chip.key)}
            className={cn(
              'inline-flex h-8 shrink-0 items-center gap-1.5 whitespace-nowrap rounded-full border px-3 text-[13px] transition-colors',
              active
                ? 'border-primary/50 bg-primary/10 text-primary'
                : 'border-border text-foreground hover:border-primary/40',
            )}
          >
            {ICONS[chip.key]}
            {t(`lists.filters.${chip.key}`)}
            {chip.count !== null && (
              <span className={cn('text-xs', active ? 'text-primary/75' : 'text-muted-foreground')}>
                {chip.count}
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
}
